import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import masterServices from '../../Services/masterService'
import Loader from '../../Components/Loader'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
// import { BiExport, BiImport } from "react-icons/bi"

export const EditWarehouse = () => {

    const [loader, setLoader] = useState(false)
    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            name: '',
            short_name: '',
            address: '',
            map_address: '',
            ownership: '',
            remarks: '',
            contact_person: '',
            email: '',
            contact_phone: '',
            status: ''
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required('Required'),
            short_name: Yup.string().required('Required'),
            address: Yup.string().required('Required'),
            map_address: Yup.string(),
            ownership: Yup.string().required('Required'),
            remarks: Yup.string().required('Required'),
            contact_person: Yup.string().required('Required'),
            email: Yup.string().email('Invalid email').required('Required'),
            contact_phone: Yup.string().required('Required'),
            status: Yup.string().required('Required')
        }),
        onSubmit: values => {
            setLoader(true)
            masterServices.update_warehouse(values).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/warehouse-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    useEffect(() => {
        getDetail()
        // eslint-disable-next-line
    }, [])

    const getDetail = () => {
        let data = history.location.state
        formik.setValues({
            ...formik.values,
            id: data._id,
            name: data.name,
            short_name: data.short_name,
            address: data.address,
            map_address: data.map_address || '',
            ownership: data.ownership,
            remarks: data.remarks,
            contact_person: data.contact_person || '',
            email: data.email || '',
            contact_phone: data.contact_phone || '',
            status: data.status
        })

    }

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="" htmlFor="country currency">Name</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.name ? !formik.errors.name ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('name')}
                                            placeholder="Enter Name"
                                        />
                                        {formik.touched.name && formik.errors.name ? (
                                            <div className="text-danger">{formik.errors.name}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Short Name</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.short_name ? !formik.errors.short_name ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('short_name')}
                                            placeholder="Enter Short Name"
                                        />
                                        {formik.touched.short_name && formik.errors.short_name ? (
                                            <div className="text-danger">{formik.errors.short_name}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Address</label>
                                    </div>
                                    <div className="col-9">
                                        <textarea
                                            className={'form-control' + (formik.touched.address ? !formik.errors.address ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('address')}
                                            placeholder="Enter Address"
                                            rows="3"
                                        />
                                        {formik.touched.address && formik.errors.address ? (
                                            <div className="text-danger">{formik.errors.address}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Map Address</label>
                                    </div>
                                    <div className="col-9">
                                        <textarea
                                            className={'form-control' + (formik.touched.map_address ? !formik.errors.map_address ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('map_address')}
                                            placeholder="Enter Map Address Link / Text"
                                            rows="2"
                                        />
                                        {formik.touched.map_address && formik.errors.map_address ? (
                                            <div className="text-danger">{formik.errors.map_address}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Ownership</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.ownership ? !formik.errors.ownership ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('ownership')}
                                            placeholder="Enter Ownership"
                                        />
                                        {formik.touched.ownership && formik.errors.ownership ? (
                                            <div className="text-danger">{formik.errors.ownership}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Remarks</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.remarks ? !formik.errors.remarks ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('remarks')}
                                            placeholder="Enter Remarks"
                                        />
                                        {formik.touched.remarks && formik.errors.remarks ? (
                                            <div className="text-danger">{formik.errors.remarks}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Contact Person Name</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className={'form-control' + (formik.touched.contact_person ? !formik.errors.contact_person ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('contact_person')}
                                            placeholder="Enter Contact Person"
                                        />
                                        {formik.touched.contact_person && formik.errors.contact_person ? (
                                            <div className="text-danger">{formik.errors.contact_person}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Email</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="email"
                                            className={'form-control' + (formik.touched.email ? !formik.errors.email ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('email')}
                                            placeholder="Enter Email"
                                        />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="text-danger">{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Contact Phone</label>
                                    </div>
                                    <div className="col-9">
                                        <PhoneInput
                                            country={'ae'}
                                            value={formik.values.contact_phone}
                                            onChange={phone => formik.setFieldValue('contact_phone', phone)}
                                            inputClass={'form-control' + (formik.touched.contact_phone && formik.errors.contact_phone ? ' is-invalid' : '')}
                                        />
                                        {formik.touched.contact_phone && formik.errors.contact_phone ? (
                                            <div className="text-danger">{formik.errors.contact_phone}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="mt-3 d-flex justify-content-between">
                                    <button
                                        className="btn btn-danger w-sm waves-effect waves-light"
                                        type="button"
                                        onClick={() => history.goBack()}
                                    >Back</button>
                                    <button className="btn btn-primary w-sm waves-effect waves-light"
                                        type="button"
                                        onClick={() => formik.handleSubmit()}
                                    >Submit</button>
                                </div>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
